<template>
  <div class="user-detail" v-loading="loading">
    <div class="user-info" v-if="detail">
      <div class="user-profile">
        <div class="avatar">
          <img :src="detail.avatar || '/images/default-avatar.jpg'" alt="" />
        </div>
        <div class="name">
          <p>{{ detail.name }}</p>
        </div>
      </div>
      <p>
        <span>用户ID：</span>
        <span>{{ detail.id }}</span>
      </p>
      <p>
        <span>用户类型：</span>
        <el-tag v-if="detail.type === 1" type="info">普通用户</el-tag>
        <el-tag v-if="detail.type === 2" type="success">主播</el-tag>
        <el-tag v-if="detail.type === 7" type="success">主播（新）</el-tag>
        <el-tag v-if="detail.type === 4" type="warning">代理</el-tag>
        <el-tag v-if="detail.type === 6" type="warning">试用期代理</el-tag>
      </p>
      <p>
        <span>用户等级：</span>
        <span>{{ detail.level && detail.level.name }}</span>
      </p>
      <p>
        <span>用户余额：</span>
        <span>${{ detail.account_balance }}</span>
      </p>
      <p>
        <span>电话号码：</span>
        <span>{{ detail.phone }}</span>
      </p>
      <p>
        <span>邮箱：</span>
        <span>{{ detail.email }}</span>
      </p>
      <p>
        <span>联系QQ：</span>
        <span>{{ detail.qq_id }}</span>
      </p>
      <p>
        <span>交易url：</span>
        <span class="url">{{ detail.transaction_url }}</span>
        <el-input placeholder="请输入内容" v-model="user_transaction_url">
          <el-button slot="append" @click="setTransactionUrl">修改</el-button>
        </el-input>
      </p>
      <p>
        <span>上级用户：</span>
        <span class="url">{{ detail.pid }}</span>
      </p>
      <div v-if="detail.type === 2 || detail.type === 7">
        <el-divider>主播推广</el-divider>
        <div v-if="detail.anchor === null">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="账号">
              <el-input v-model="form.account"></el-input>
            </el-form-item>
            <!--						<el-form-item label="密码">-->
            <!--							<el-input v-model="form.password"></el-input>-->
            <!--						</el-form-item>-->
            <!--						<el-form-item label="总金额">-->
            <!--							<el-input v-model="form.total_amount"></el-input>-->
            <!--						</el-form-item>-->
            <el-form-item label="可提金额">
              <el-input v-model="form.amount"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即提交</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-else>
          <p>
            <span>账号：</span>
            <span class="url">{{ detail.anchor.account }}</span>
          </p>
          <p>
            <span>密码：</span>
            <span class="url">{{ detail.anchor.real_password }}</span>
          </p>
          <p>
            <span>总金额：</span>
            <span class="url">{{ detail.anchor.total_amount }}</span>
          </p>
          <p>
            <span>已提金额：</span>
            <span class="url">{{ detail.anchor.settlement_amount }}</span>
          </p>
          <p>
            <span>剩余金额：</span>
            <span class="url">{{ detail.anchor.amount }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="data-table">
      <el-tabs v-model="activeTable" class="table-box">
        <el-tab-pane label="用户背包" name="bag"></el-tab-pane>
        <el-tab-pane label="余额日志" name="balance"></el-tab-pane>
        <el-tab-pane label="充值记录" name="recharge"></el-tab-pane>
        <el-tab-pane label="cdk充值记录" name="cdk"></el-tab-pane>
        <el-tab-pane label="流转日志" name="prize"></el-tab-pane>
        <el-tab-pane label="下级用户" name="subs"></el-tab-pane>
        <el-tab-pane label="链接修改日志" name="url"></el-tab-pane>
        <el-tab-pane label="登录IP日志" name="ip"></el-tab-pane>
        <el-tab-pane label="下级管理" name="anchor"></el-tab-pane>
        <el-tab-pane label="上级管理" name="superior"></el-tab-pane>
        <el-tab-pane label="主播记录" name="anchor_log"></el-tab-pane>
      </el-tabs>
      <UserBag :id="id" v-if="activeTable === 'bag'"></UserBag>
      <UserBalanceLogs :id="id" v-if="activeTable === 'balance'"></UserBalanceLogs>
      <UserCdkLogs :id="id" v-if="activeTable === 'cdk'"></UserCdkLogs>
      <UserRechargeLogs :id="id" v-if="activeTable === 'recharge'"></UserRechargeLogs>
      <UserPrizeLogs :id="id" v-if="activeTable === 'prize'"></UserPrizeLogs>
      <!-- <UserSubordinate
        :id="id"
        :subordinateList="detail.subordinate_user"
        v-if="detail && activeTable === 'subs'"
      ></UserSubordinate> -->
      <UserSubordinate :id="id" v-if="detail && activeTable === 'subs'"></UserSubordinate>
      <UserUrlLogs :id="id" v-if="activeTable === 'url'"></UserUrlLogs>
      <UserIpLog :id="id" v-if="activeTable === 'ip'"></UserIpLog>
      <UserAnchor :id="id" v-if="activeTable === 'anchor'"></UserAnchor>
      <UserSuperior :id="id" v-if="activeTable === 'superior'"></UserSuperior>
      <AnchorLog :id="id" v-if="activeTable === 'anchor_log'"></AnchorLog>
    </div>
  </div>
</template>

<script>
import { getData, postData, patchData } from '../../http'
import UserBag from './UserBag'
import UserBalanceLogs from './UserBalanceLogs'
import UserRechargeLogs from './UserRechargeLogs'
import UserPrizeLogs from './UserPrizeLogs'
import UserSubordinate from './UserSubordinate'
import UserUrlLogs from './UserUrlLogs'
import UserIpLog from './UserIpLog'
import UserAnchor from './UserAnchor'
import UserCdkLogs from './UserCdkLogs'
import UserSuperior from './UserSuperior'
import AnchorLog from './AnchorLog'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    UserBag,
    UserBalanceLogs,
    UserRechargeLogs,
    UserPrizeLogs,
    UserSubordinate,
    UserUrlLogs,
    UserCdkLogs,
    UserIpLog,
    UserAnchor,
    UserSuperior,
    AnchorLog
  },
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      detail: undefined,
      loading: false,
      activeTable: 'bag',
      user_transaction_url: '',//要修改的用户的交易链接
      form: {
        user_id: '',
        account: '',
        password: '',
        total_amount: '',
        amount: ''
      }
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    })
  },
  methods: {
    ...mapActions(['getCategories']),
    getUserDetail() {
      this.loading = true
      getData(`users/${this.id}`)
        .then(res => {
          this.detail = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSubmit() {
      this.form.user_id = this.detail.id
      postData('anchors', this.form)
        .then(res => {
          this.getUserDetail()
        }).finally(() => {
        })
    },
    setTransactionUrl() {
      //修改用户交易链接
      this.$confirm('确定要修改交易链接吗？', {
        type: 'warning'
      }).then(res => {
        let params = {
          transaction_url: this.user_transaction_url
        }
        patchData(`edit_user_url/${this.id}`, params)
          .then(res => {
            this.$message.success("修改成功！")
            this.getUserDetail()
          }).finally(() => {
          })
      })
    }
  },
  created() {
    this.getUserDetail()
    !this.categories && this.getCategories()
  }
}
</script>

<style lang="less" scoped>
// @media (max-width: 900px) {
//   .user-detail {
//     flex-direction: column;
//     .data-table {
//       padding: 0px 10px;
//       overflow-x: auto;
//       .table-box {
//       }
//     }
//   }
// }
</style>
